"use client";

import React from "react";
import { Headphones, MessageCircle, Ticket } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NeedHelp() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="99049" id="commandez-sur-whatsapp" className="bg-background text-foreground relative py-24 md:py-32 overflow-hidden">
      {}


      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-5xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="rounded-3xl bg-gradient-to-r from-primary via-accent to-primary p-[1px] shadow-2xl shadow-primary/10">
           
            <div className="rounded-[calc(1.5rem-1px)] bg-secondary/70 backdrop-blur-2xl p-8 md:p-16 flex flex-col items-center text-center relative overflow-hidden">
              
              {}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-32 bg-accent/20 blur-[100px] rounded-full pointer-events-none" />

              <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-primary/10 to-accent/10 flex items-center justify-center mb-8 border border-primary/10 shadow-lg backdrop-blur-md relative z-10">
                <MessageCircle className="w-10 h-10 text-primary drop-shadow-[0_0_15px_rgba(var(--color-primary),0.3)]" />
              </div>

              <h2 className="text-4xl md:text-6xl font-serif font-bold mb-6 tracking-tight text-primary relative z-10">
                Commande Rapide par WhatsApp
              </h2>
              
              <p className="text-lg md:text-xl text-muted-foreground mb-12 max-w-3xl relative z-10 leading-relaxed font-sans">Réponse rapide en quelques minutes</p>

              <div className="flex flex-col sm:flex-row gap-5 w-full sm:w-auto relative z-10">
                <Button asChild size="lg" className="w-full sm:w-auto h-14 px-8 text-base font-semibold bg-primary text-secondary shadow-[0_0_30px_-5px_rgba(var(--color-primary),0.4)] hover:shadow-[0_0_40px_-5px_rgba(var(--color-primary),0.6)] transition-all duration-300 animate-pulse">
                  <Link to={`https://wa.me/221781666638?text=${encodeURIComponent("Bonjour KBC Coffee Service . Je souhaite commander du café . Pouvez-vous me proposer une offre adaptée ? Merci.")}`} newTab>
                    Commander sur WhatsApp
                  </Link>
                </Button>
                
                <Button asChild variant="outline" size="lg" className="w-full sm:w-auto h-14 px-8 text-base font-semibold border-primary/20 bg-primary/5 text-primary hover:bg-primary/10 hover:text-primary backdrop-blur-sm transition-all duration-300">
                  <Link to="/MachinesPage">
                    <Ticket className="mr-2 w-5 h-5" />
                    Voir nos machines
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}